<template>
  <v-container>
    <v-row align="center" justify="center">
      <h1>Términos y Condiciones</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-expansion-panels>
        <v-expansion-panel v-for="(termino, i) in terminos" :key="i">
          <v-expansion-panel-header>
            {{ termino.Titulo }}
            <template v-slot:actions>
              <v-icon x-large color="primary">$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="#E5EAF0">
              <p v-for="(indice, i) in termino.Texto" :key="i">
                  {{indice.Subtexto}}
              </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import terminos from "../statics/terminos.json";

export default {
    data() {
        return {
            terminos
        }
    }
};
</script>

<style>
</style>